import React from "react";
import { AlertTriangle, X, Trash2, Loader2 } from "lucide-react";

/* ================================================================
   Nexus One · Shared destructive-confirm modal
   Dark theme, violet + amber warning glyph, red accent on the CTA.
   ================================================================ */
export default function ConfirmDeleteModal({
    open,
    title,
    body,
    confirmLabel = "Delete",
    cancelLabel = "Cancel",
    onConfirm,
    onClose,
    busy = false,
    confirmTestid = "skill-delete-confirm",
    cancelTestid = "skill-delete-cancel",
}) {
    if (!open) return null;
    return (
        <div
            className="fixed inset-0 z-[60] grid place-items-center p-6"
            style={{ background: "rgba(2,4,10,0.72)", backdropFilter: "blur(4px)" }}
            onClick={() => !busy && onClose?.()}
            data-testid="skill-delete-modal"
        >
            <div
                className="atlas-card atlas-card--elevated w-full max-w-md p-5"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-start justify-between gap-3">
                    <div className="flex items-start gap-3 min-w-0">
                        <div
                            className="w-9 h-9 rounded-lg grid place-items-center flex-shrink-0"
                            style={{
                                background: "rgba(239,68,68,0.14)",
                                border: "1px solid rgba(239,68,68,0.45)",
                            }}
                        >
                            <AlertTriangle
                                className="w-4 h-4"
                                strokeWidth={2.25}
                                style={{ color: "#f87171" }}
                            />
                        </div>
                        <div className="min-w-0">
                            <div
                                className="text-[15.5px] font-semibold"
                                style={{ color: "var(--atlas-text-primary)" }}
                            >
                                {title}
                            </div>
                            <p
                                className="mt-1 text-[13px] leading-relaxed"
                                style={{ color: "var(--atlas-text-tertiary)" }}
                            >
                                {body}
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={() => !busy && onClose?.()}
                        disabled={busy}
                        style={{ color: "var(--atlas-text-muted)" }}
                        className="hover:opacity-100 opacity-70 transition-opacity disabled:opacity-40"
                    >
                        <X className="w-4 h-4" strokeWidth={2} />
                    </button>
                </div>
                <div
                    className="mt-5 pt-4 flex items-center justify-end gap-2"
                    style={{ borderTop: "1px solid var(--atlas-border)" }}
                >
                    <button
                        onClick={() => !busy && onClose?.()}
                        disabled={busy}
                        data-testid={cancelTestid}
                        className="atlas-btn-ghost inline-flex items-center rounded-lg px-3 h-9 text-[12.5px]"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={busy}
                        data-testid={confirmTestid}
                        className="inline-flex items-center gap-1.5 rounded-lg px-3.5 h-9 text-[12.5px] font-medium transition-all disabled:opacity-60"
                        style={{
                            background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                            color: "#fff",
                            boxShadow:
                                "0 0 0 1px rgba(239,68,68,0.55), 0 6px 18px -6px rgba(220,38,38,0.55)",
                        }}
                    >
                        {busy ? (
                            <Loader2 className="w-3.5 h-3.5 animate-spin" strokeWidth={2.25} />
                        ) : (
                            <Trash2 className="w-3.5 h-3.5" strokeWidth={2.25} />
                        )}
                        {busy ? "Deleting…" : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
